<mat-drawer-container class="container-menu-lateral" autosize>
    <mat-drawer #drawer [opened]="menuAberto" class="menu-lateral" [ngClass]="{'menu-dark': theme == 'dark'}" [mode]="modoMenu">

        <div class="logo-menu-lateral">
            <img [src]="urlLogoHorizontal" height="100px" />
        </div>

        <mat-nav-list>
            <ng-container *ngFor="let route of rotasListar">
                <a
                    [routerLink]="route.path"
                    class="item-menu"
                    [ngClass]="{
                        'rota-selecionada': currentRoute && currentRoute.includes(route.path!)
                    }"
                >
                    <mat-list-item>
                        <mat-icon class="me-2">{{ route.icon }}</mat-icon>
                        {{ route.text }}
                    </mat-list-item>
                </a>
            </ng-container>
        </mat-nav-list>
    </mat-drawer>

    <mat-drawer-content class="pb-3" [ngClass]="{'background-dark': theme == 'dark'}">
        <ng-content></ng-content>
    </mat-drawer-content>
</mat-drawer-container>
